module.exports = __webpack_public_path__ + "static/media/  (137).637cdfc8.jpg";